import React, {useContext, useMemo} from 'react';
import dayjs from "dayjs";
import LogTemplate from "./LogTemplate";
import {AuthContext} from "../../shared/contexts/authContext";
import GoToUserInfoButton from "../../shared/components/buttons/GoToUserInfoButton";
import {useItemKrTextData} from "../probability/useItemData";
import IsLoading from "../../shared/components/IsLoading";
import ErrorPage from "../../shared/components/ErrorPage";
import {getMailLogColumns} from "./columns/mailLogColumns";

const MailLog = () => {
    const { currentUser } = useContext(AuthContext);
    const { data: krItemTextData, isLoading, error } = useItemKrTextData();

    const searchParams = useMemo(() => ({
        begin: dayjs().subtract(1, "week").startOf('day').format('YYYY-MM-DD HH:mm:ss'),
        end: dayjs().endOf('day').format('YYYY-MM-DD HH:mm:ss'),
        logType: 'mailTrash',
        isUnix: false,
    }), []);

    const columns = useMemo(() => ([
        {
            title: 'PID',
            dataIndex: 'pid',
            search: true,
        },
        {
            title: '유저 이름',
            dataIndex: 'name',
            search: true,
        },
        ...getMailLogColumns(krItemTextData, currentUser),
        {
            title: '유저 정보',
            dataIndex: 'pid',
            render: (pid) => <GoToUserInfoButton pid={pid} />,
        },
    ]), [krItemTextData, currentUser]);

    if (isLoading) return <IsLoading />;
    if (error) return <ErrorPage error={error} />;
    return (
        <LogTemplate
            columns={columns}
            defaultSearchParams={searchParams}
            routerUrl={'/logs'}
            logName={'MailLog'}
        />
    );
};

export default MailLog;